import { LOCATION_CHANGE } from 'connected-react-router';
import EventEmitter from 'events';
import {
  SAVE_SLIP_BUTTON_CLICKED,
  SET_EVENTS_DAY,
  SLIP_SAVED,
  SLIP_SELECTION_ADD,
  SLIP_SELECTION_DESELECT
} from '../../containers/bettingBuddy/actions';
import {
  getCurrentSlipBetType,
  getCurrentSlipName,
  getCurrentSlipOdds,
  getCurrentSlipSelections,
  getCurrentSlipStake,
  getEventsDay
} from '../../containers/bettingBuddy/selectors';
import { locationChange } from '../../modules/analytics/actions';
import { getCompetitionByEventId } from '../../modules/events/selectors';
import getDatesRange from '../dates/getDatesRange';

window.analytics = new EventEmitter();

const analyticsMiddleware = store => next => action => {
  const { type } = action;
  switch (type) {
    case SET_EVENTS_DAY: {
      const nextWeek = getDatesRange();
      window.analytics.emit('bettingBuddy/EVENTS_DATE_CHANGE', {
        action: {
          dayOfWeek: nextWeek[action.day].fullDayName,
          date: `${nextWeek[action.day].dayNumber} ${nextWeek[action.day].fullMonthName}`
        }
      });
      break;
    }
    case SLIP_SELECTION_ADD:
    case SLIP_SELECTION_DESELECT: {
      const state = store.getState();
      const {
        selection: {
          selectionId,
          selectionName,
          selectionPriceNum,
          selectionPriceDen,
          eventId,
          eventName,
          eventStartDateTime,
          marketName
        }
      } = action;
      const competition = getCompetitionByEventId(state, { eventId });
      const nextWeek = getDatesRange();
      const day = getEventsDay(state);
      const nexWeekDay = nextWeek[day];

      window.analytics.emit(type, {
        action: {
          type,
          selectionId,
          marketName,
          eventName,
          date: eventStartDateTime,
          competition: competition.competitionName,
          tabName: nexWeekDay.dayName,
          selectionName,
          priceNumerator: selectionPriceNum,
          priceDenominator: selectionPriceDen
        }
      });
      break;
    }
    case SLIP_SAVED:
    case SAVE_SLIP_BUTTON_CLICKED: {
      const state = store.getState();
      const name = getCurrentSlipName(state);
      const stake = getCurrentSlipStake(state);
      const selections = getCurrentSlipSelections(state);
      const odds = getCurrentSlipOdds(state);
      const betType = getCurrentSlipBetType(state);

      window.analytics.emit(type, {
        action: {
          type,
          numberOfSelections: selections.size,
          single: (selections.size === 1) ? 1 : 0,
          multiple: (selections.size > 1) ? 1 : 0,
          betType,
          name,
          odds,
          stake
        }
      });
      break;
    }
    case LOCATION_CHANGE: {
      const previousPath = store
        .getState()
        .getIn(['router', 'location', 'pathname']);
      const currentPath = action.payload.pathname;
      const analyticsAction = locationChange({ previousPath, currentPath });
      window.analytics.emit(analyticsAction.type, {
        action: analyticsAction
      });
      break;
    }
    default: {
      window.analytics.emit(type, {
        action,
        store: store.getState()
      });
    }
  }

  window.analytics.emit('*', {
    action,
    store: store.getState()
  });

  return next(action);
};

export default analyticsMiddleware;
